// Angular
import { Injectable } from "@angular/core";
// External
import { FirebaseApp } from "angularfire2";
import { AngularFireDatabase } from "angularfire2/database";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap } from "rxjs/operators";
import { environment } from "./../../../environments/environment";
import { resolve } from "url";

@Injectable()
export class ApiService {
  public httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:
        "Basic " + btoa(environment.userName + ":" + environment.password),
    }),
  };
  public baseUrl = environment.baseUrl;
  constructor(
    private firebaseApp: FirebaseApp,
    private http: HttpClient,
    private fireDatabase: AngularFireDatabase
  ) {}

  object(path: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const objectSubscription = this.fireDatabase.object(path).subscribe(
        (result) => {
          resolve(result);
          if (objectSubscription) {
            objectSubscription.unsubscribe();
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  object1(path: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const objectSubscription = this.fireDatabase.object(path).subscribe(
        (result) => {
          resolve(result);
          if (objectSubscription) {
            objectSubscription.unsubscribe();
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  list1(path: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const listSubscription = this.fireDatabase.list(path).subscribe(
        (list) => {
          resolve(list);
          if (listSubscription) {
            listSubscription.unsubscribe();
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  list(path: string, options?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const listSubscription = this.fireDatabase.list(path, options).subscribe(
        (result) => {
          resolve(result);
          if (listSubscription) listSubscription.unsubscribe();
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  push(path: string, value: any) {
    return this.fireDatabase.database.ref(path).push(value);
  }

  set(path: string, value: any) {
    return this.fireDatabase.database.ref(path).set(value);
  }

  update(path: string, value: any) {
    return this.fireDatabase.object(path).update(value);
  }

  upload(path: string, filename: string, file: File, metadata?: any) {
    return this.firebaseApp
      .storage()
      .ref(path)
      .child(filename)
      .put(file, metadata);
  }

  remove(path: string) {
    return this.fireDatabase.object(path).remove();
  }
  getKey(path: string): string {
    return this.fireDatabase.database.ref().child(path).push().key;
  }

  bulkUpdate(updates: object) {
    return this.fireDatabase.database.ref().update(updates);
  }
  get(url): Promise<any> {
    return this.http.get(this.baseUrl + url, this.getHeaders()).toPromise();
  }
  getHeaders() {
    return this.httpOptions;
  }
}
